var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-new",style:(_vm.wrapStyle)},[_c('div',{staticClass:"empty-news-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }